import { render, staticRenderFns } from "./search-dashboard.vue?vue&type=template&id=4fe7bb8b"
import script from "./search-dashboard.vue?vue&type=script&lang=js"
export * from "./search-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports